import {
  REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST,
  REPATRIATIONS_TRANSACTIONS_DELETE_SUCCESS,
  REPATRIATIONS_TRANSACTIONS_DELETE_FAILURE,
} from './types/InternalRepatriationsTransactionsDeleteActionsTypes';

export function deleteRepatriationsTransactionsDeleteRequestActionCreator(context,
  newDescription,
  newTransactionId) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST,
    payload: {
      appContext: context,
      params: {
        description: newDescription,
        transactionId: newTransactionId,
      },
    },
  };
}

export function deleteRepatriationsTransactionsDeleteSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteRepatriationsTransactionsDeleteFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
